module.exports = __webpack_public_path__ + "img/20200507_133413.55cff8b7.jpg";